import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = []

  removeParams() {
    const currentUrl = new URL(window.location.href);
    currentUrl.search = '';
    window.history.replaceState(null, '', currentUrl);
  }
}
